import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { apiService } from '../services/api';
import './IntegrationApiKey.css';

const IntegrationApiKey = () => {
  const [loading, setLoading] = useState(false);
  const [apiToken, setApiToken] = useState('');
  const [tokenMeta, setTokenMeta] = useState(null);
  const [webhookSaving, setWebhookSaving] = useState(false);
  const [webhookResult, setWebhookResult] = useState(null);
  const [webhookForm, setWebhookForm] = useState({
    override_callback_uri: '',
    verify_token: ''
  });

  const handleFetchApiKey = async () => {
    setLoading(true);
    try {
      const res = await apiService.integrations.getToken();
      const payload = res.data?.data || res.data || {};
      const token = payload.apiToken || '';

      setApiToken(token);
      setTokenMeta(payload);

      if (!token) {
        toast.warn('API key response received, but no token field was found.');
      } else {
        toast.success('API key fetched successfully');
      }
    } catch (err) {
      const message = err?.response?.data?.message || 'Failed to fetch API key';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    if (!apiToken) {
      toast.error('No API key to copy');
      return;
    }

    try {
      await navigator.clipboard.writeText(apiToken);
      toast.success('API key copied to clipboard');
    } catch {
      toast.error('Failed to copy API key');
    }
  };

  const handleWebhookOverride = async (e) => {
    e.preventDefault();

    if (!webhookForm.override_callback_uri.trim() || !webhookForm.verify_token.trim()) {
      toast.error('Webhook URL and verify token are required');
      return;
    }

    setWebhookSaving(true);
    try {
      const res = await apiService.integrations.overrideWebhook({
        override_callback_uri: webhookForm.override_callback_uri.trim(),
        verify_token: webhookForm.verify_token.trim(),
      });

      setWebhookResult(res.data?.data || res.data || null);
      toast.success(res.data?.message || 'Webhook override updated');
    } catch (err) {
      const message = err?.response?.data?.message || 'Failed to override webhook';
      toast.error(message);
    } finally {
      setWebhookSaving(false);
    }
  };

  return (
    <div className="integration-key-page">
      <div className="integration-key-card">
        <h2>Integration API Key</h2>
        <p className="integration-key-subtitle">
          Generate your API key from: http://localhost:5000/api/v1/integrations/token
        </p>

        <div className="integration-key-actions">
          <button
            type="button"
            className="btn-fetch-key"
            onClick={handleFetchApiKey}
            disabled={loading}
          >
            {loading ? 'Fetching...' : 'Get API Key'}
          </button>

          <button
            type="button"
            className="btn-copy-key"
            onClick={handleCopy}
            disabled={!apiToken}
          >
            Copy
          </button>
        </div>

        <div className="integration-key-output">
          <label>API Key</label>
          <textarea
            value={apiToken}
            readOnly
            rows={4}
            placeholder="Click 'Get API Key' to fetch token"
          />
        </div>

      

        <div className="integration-key-meta">
          <h3>Webhook Override</h3>
          <form className="webhook-form" onSubmit={handleWebhookOverride}>
            <div className="webhook-field">
              <label>Override Callback URI</label>
              <input
                type="url"
                value={webhookForm.override_callback_uri}
                onChange={(e) => setWebhookForm((prev) => ({ ...prev, override_callback_uri: e.target.value }))}
                placeholder="https://your-domain.com/webhook"
                required
              />
            </div>
            <div className="webhook-field">
              <label>Verify Token</label>
              <input
                type="text"
                value={webhookForm.verify_token}
                onChange={(e) => setWebhookForm((prev) => ({ ...prev, verify_token: e.target.value }))}
                placeholder="Enter verification token"
                required
              />
            </div>
            <button type="submit" className="btn-fetch-key" disabled={webhookSaving}>
              {webhookSaving ? 'Updating...' : 'Update Webhook Override'}
            </button>
          </form>

          {webhookResult && (
            <pre className="webhook-result">{JSON.stringify(webhookResult, null, 2)}</pre>
          )}
        </div>
      </div>
    </div>
  );
};

export default IntegrationApiKey;
